<template>
  <div>
    <div class="container content">
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <a href="https://www.swau.edu"><img src="../assets/logo2.png" alt="Southwestern Adventist University" style="width:100%; padding: 40px;"></a>
          <div class="alert alert-danger" v-if="error">
            <h3>Error</h3>
            <p>{{ error }}</p>
          </div>
          <h1 class="text-center" style="font-weight: 200; letter-spacing: 1px;">Are you lost?</h1>
          <h2 class="text-center" style="font-weight: 200; letter-spacing: 1px;"><a href="https://www.swau.edu">www.swau.edu</a></h2>
          <h3 class="text-center" style="font-weight: 200; letter-spacing: 1px;margin-top: 100px;">404 - Page Not Found</h3>
        </div>
      </div>
    </div>
    <footer>
      <div class="container text-center">
        <div class="row">
          <div class="col-md-12">
            <p id="copyright">&copy; {{ year }} Southwestern Adventist University</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue